export const config = {
    type: 'FAQ',
    title: '常见问题',
    defaultProps: {
        items: [
            {
                question: '问题1',
                answer: '回答1'
            },
            {
                question: '问题2',
                answer: '回答2'
            }
        ]
    },
    preview: {
        style: {
            padding: '8px'
        },
        items: [
            {
                style: {
                    width: '100%',
                    height: '16px',
                    background: 'var(--semi-color-fill-2)',
                    marginBottom: '12px'
                }
            },
            {
                style: {
                    width: '90%',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)',
                    marginBottom: '8px'
                }
            },
            {
                style: {
                    width: '85%',
                    height: '12px',
                    background: 'var(--semi-color-fill-1)'
                }
            }
        ]
    }
};